import { SxProps, Theme } from '@mui/material';

import { ButtonWithPopover } from '@/components/form/baseInputs/Button/ButtonWithPopover';
import { File05Icon } from '@/components/icons/File05Icon';
import { MenuItem } from '@/components/poppers/MenuPopper/MenuItem';
import { SelectableDocument } from '@/modules/documents/ManageDocumentAmendments/types';
import { truncateToEllipis } from '@/utils/formatting/strings';

interface DocumentVersionSelectorProps {
  documents: SelectableDocument[];
  activeDocumentId: string;
  onSelectDocument: (documentId: string) => void;
  sx?: SxProps<Theme>;
}

export function DocumentVersionSelector({
  documents,
  activeDocumentId,
  onSelectDocument,
  sx = {},
}: DocumentVersionSelectorProps) {
  if (documents.length <= 1) {
    return null;
  }

  const activeDocument = documents.find((doc) => doc.id === activeDocumentId);

  return (
    <ButtonWithPopover
      size="sm"
      variant="secondary"
      popperVariant="menuBelow"
      popperProps={{
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left',
        },
      }}
      startIcon={File05Icon}
      label={truncateToEllipis(activeDocument?.name, 70) || 'Select document'}
      sx={{ ...sx }}
    >
      {documents.map((document) => (
        <MenuItem
          key={document.id}
          label={document.name}
          onClick={() => onSelectDocument(document.id)}
          muiMenuItemProps={{
            selected: document.id === activeDocumentId,
          }}
          typographyProps={{
            maxWidth: 400,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        />
      ))}
    </ButtonWithPopover>
  );
}
